import { mixin as clickaway } from 'vue-clickaway';

import template from './select-box.vhtml';

export default {
	mixins: [clickaway],
	template: template,
	props: {
		color: {
			type: String,
			default: '',
		},
		options: {
			type: Array,
			default: null,
		},
		popupDirection: {
			type: String,
			default: '',
		},
		language: {
			type: String,
			default: 'da', 
		},
	},
	data: () => ({
		isOpen: false,
	}),
	computed: {
		popupClass() {
			return 'o-select-box__popup--' + this.popupDirection;
		},
		popupInnerClass() {
			return 'o-select-box__popup-inner--' + this.popupDirection;
		},
	},
	methods: {
		openBox() {
			this.isOpen = true;
		},
		closeBox() {
			this.isOpen = false;
		},
		downloadFile(file) {
			this.$emit('downloadFile', file);
		}
	},
};


// WEBPACK FOOTER //
// ./assets/_js/components/select-box/select-box.js